import { makeValuesPredicate } from '@sgme/fp';
import type { IntlKey } from 'locales';
import {
  type ActionName,
  bookableActionNames,
  execOnlyActionNames,
  primaryActionNames,
  type QuoteAction,
  tradableActionNames,
} from 'state/common-form/infos/infos.model';
import { logFrontError } from 'utils/errors/logFrontError';
import { camelCaseToWords } from 'utils/string';
export function getTranslationKeyForAction(action: QuoteAction | undefined): IntlKey {
  if (!action) {
    return 'form.buttons.Unknown';
  }

  return getTranslationKeyFromActionName(action.name);
}

const isPrimaryActionName = makeValuesPredicate(primaryActionNames);

export function getTranslationKeyFromActionName(actionName: ActionName): IntlKey {
  if (isPrimaryActionName(actionName)) {
    return `form.buttons.${actionName}`;
  }
  const error = new Error(`Action button named '${actionName}' is not yet handled in front`);
  logFrontError('Failed to get translation key for side panel action button {@FrontError}', error);
  return 'form.buttons.Unknown';
}

export const isTradeAction = makeValuesPredicate([
  ...execOnlyActionNames,
  ...tradableActionNames,
  ...bookableActionNames,
]);

export function getDefaultLabelFromAction(action: QuoteAction | undefined): string {
  if (!action) {
    return '';
  }

  return camelCaseToWords(action.name);
}
